module.exports = __webpack_public_path__ + "./static/img/home.4f0f6d20881743b24a69d49099951aca.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/fontawesome/home.png
// module id = ./client/src/assets/fontawesome/home.png
// module chunks = 0